import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { BranchInfo } from '../../types'
import './BranchContact.css'

interface BranchContactProps {
  branch?: BranchInfo | null
}

// Карточка ДЦ: логотип, название, адрес, контакты и кнопки связи
export default function BranchContact({ branch }: BranchContactProps) {
  const { t } = useTranslation()
  const [logoFailed, setLogoFailed] = useState(false)

  if (!branch || (!branch.phone && !branch.email && !branch.address)) {
    return null
  }

  const showLogo = !!branch.logoUrl && !logoFailed

  return (
    <section className="branch-contact" aria-label={branch.name}>
      <div className="branch-contact__head">
        <div className="branch-contact__logo">
          {showLogo ? (
            <img src={branch.logoUrl!} alt="" onError={() => setLogoFailed(true)} />
          ) : (
            <span className="branch-contact__initials">{getInitials(branch.name)}</span>
          )}
        </div>
        <div className="branch-contact__title">
          <h2 className="branch-contact__name">{branch.name}</h2>
          {branch.address && <p className="branch-contact__address">{branch.address}</p>}
        </div>
      </div>

      {(branch.phone || branch.email) && (
        <div className="branch-contact__lines">
          {branch.phone && <span>{formatPhone(branch.phone)}</span>}
          {branch.email && <span>{branch.email}</span>}
        </div>
      )}

      {(branch.phone || branch.email) && (
        <div className="branch-contact__actions">
          {branch.phone && (
            <a className="branch-contact__btn branch-contact__btn--primary" href={`tel:${branch.phone}`}>
              {t('branch_contact.call')}
            </a>
          )}
          {branch.email && (
            <a className="branch-contact__btn branch-contact__btn--secondary" href={`mailto:${branch.email}`}>
              {t('branch_contact.email')}
            </a>
          )}
        </div>
      )}
    </section>
  )
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/)
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || 'DC'
}

// +15125550148 → +1 512 555 0148; остальные номера показываем как есть
function formatPhone(e164: string): string {
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164)
  return m ? `+1 ${m[1]} ${m[2]} ${m[3]}` : e164
}
